import { Injectable, QueryList } from '@angular/core';
import { Party } from '@shared/models';
import { PartyWithRelationship } from '@shared/services/onboarding-flow';
import { IMaskDirective } from 'angular-imask';
import { MaskedNumber } from 'imask';

@Injectable({
	providedIn: 'root'
})
export class UtilityService {
	/**
	 * Opens the default email client and populate a draft email for the user to send
	 * @param emailRecipient The optional string for the recipient's email.
	 * @param emailSubject The optional string for the email's subject.
	 * @param emailBody The optional string for the email's body.
	 */
	public openEmail(
		emailRecipient?: string,
		emailSubject?: string,
		emailBody?: string
	): void {
		const mailto = `mailto:${encodeURIComponent(
			emailRecipient ?? ''
		)}?subject=${encodeURIComponent(
			emailSubject ?? ''
		)}&body=${encodeURIComponent(emailBody ?? '')}`;
		window.open(mailto);
	}

	/** Update the mask options of a specific input element.
	 * @param maskChildren The list of all the masks on the page.
	 * @param elementId The ID of the input element.
	 * @param options The new options to apply to the mask.
	 */
	public updateMaskOptions(
		maskChildren: QueryList<IMaskDirective<MaskedNumber>>,
		elementId: string,
		options: { lazy: boolean }
	): void {
		/*After digging into the IMask documentation and looking at their code implementation
	(https://github.com/uNmAnNeR/imaskjs/blob/master/packages/angular-imask/src/imask.directive.ts) they actually return
	an HTMLInputElement and so this case with unkown as well is required to access
	the element id and match it with the applied mask */
		const element = maskChildren.find(
			(el) => (el.element as unknown as HTMLInputElement).id === elementId
		);
		if (element) {
			element.maskRef?.updateOptions(options);
		}
	}
	/** Returns the Party object from the intersection of Party and PartyRelationship for posting additional shareholders
	 * Since the POST to add additional shareholders shouldn't include the relationship
	 * @param partyWithRelationship The PartyWithRelationship Object (Representing a Shareholder)
	 */
	public getPartyFromPartyWithRelationship(
		partyWithRelationship: PartyWithRelationship
	): Party {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { partyOnboardingRelationship, ...party } = partyWithRelationship;
		return party;
	}
}
